module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "form-item-content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "form-item-tip"
  }, [_vm._v(_vm._s(_vm.validateMessage))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298d2bfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormItem.vue
// module id = 506
// module chunks = 1